import { isProductCompatibleWithChartType } from "./isProductCompatibleWithChartType";

interface GetProductButtonClassParams {
  isViewMode: boolean;
  isPrimary: boolean;
  chartType: string;
  prod: string;
  isPrimaryContainingProduct: boolean;
  isSecondaryContainingProduct: boolean;
  canAddProduct: (prod: string, axis: "primary" | "secondary") => boolean;
}

export function getProductButtonClass({
  isViewMode,
  isPrimary,
  chartType,
  prod,
  isPrimaryContainingProduct,
  isSecondaryContainingProduct,
  canAddProduct
}: GetProductButtonClassParams): string {
  const compatible = isProductCompatibleWithChartType(chartType, prod);

  if (!compatible) return "notSelectable";

  if (!isViewMode) {
    if (isPrimary) {
      if (isPrimaryContainingProduct) return "isSelected";
      if (isSecondaryContainingProduct) return "isAlreadyChosen";
      if (canAddProduct(prod, "primary")) return "isSelectableViewMode";
      return "notSelectable";
    } else {
      if (isSecondaryContainingProduct) return "isSelected";
      if (isPrimaryContainingProduct) return "isAlreadyChosen";
      if (canAddProduct(prod, "secondary")) return "isSelectableViewMode";
      return "notSelectable";
    }
  } else {
    if (isPrimary) {
      if (isPrimaryContainingProduct) return "isSelectedViewMode";
      if (isSecondaryContainingProduct) return "isAlreadyChosen";
      return "isViewMode";
    } else {
      if (isSecondaryContainingProduct) return "isSelectedViewMode";
      if (isPrimaryContainingProduct) return "isAlreadyChosen";
      return "isViewMode";
    }
  }
}
